<template>
  <CRow>
    <CCol sm="12">
      <CCard>

        <CCardHeader>
          <CIcon name="cil-transfer" />
          <h5 class="d-inline ml-2">Bank Transaction List</h5>
        </CCardHeader>

        <BackendTable />
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import BackendTable from "./BackendTable";

export default {
  name: "BankTransactions",
  components: {
    BackendTable,
  },
};
</script>
